import styled from 'styled-components';
import { Button } from '@rsos/base-components';

export const RotatedButton = styled(Button)`
  rotate: -90deg;
`;

export const StartChatRcsButton = styled(Button)`
  border-radius: 5px 0px 0px 5px;
`;

export const RotatedRcsButton = styled(Button)`
  rotate: -90deg;
  border-radius: 0px 0px 5px 5px;
`;
